module.exports = __webpack_public_path__ + "img/7.10e28a14.png";